import React from 'react';
import {
	SKILL_TYPES,
	SKILL_RATINGS,
	SKILL_MAGAZINES,
	SKILL_EFFECT_TIMES,
	SKILL_RECOVERIES,
	SKILL_COOLDOWNS,
	SKILL_COOLDOWNS_FIRST,
} from './constants';

const AddSkill = ( { addNewSkill, recentlyAddedSkill, addSkillStatus } ) => {

	let statusMessageInterval = null;

	const showStatusMessage = (message, type) => {

		clearInterval(statusMessageInterval);
		document.querySelector(`.status-box-${type}`).textContent = message;
		statusMessageInterval = window.setTimeout(() => {

			showStatusMessage('', type);
		}, 3000);		
	};

	const checkIfHasEmpty = (arrayOfObjects) => {

		let hasAnEmptyObject = false;
		arrayOfObjects.forEach((obj) => {

			if ( !obj.trim() ) {

				hasAnEmptyObject = true;
			}
		});

		return hasAnEmptyObject;
	};

	const setSkillType = (event) => {

		const skillFields = [
			'skill_pierce',
			'skill_power',
			'skill_magazine',
			'skill_recovery',
			'skill_effect_time'
		];
		skillFields.forEach((field) => {

			document.querySelector(`.fields-add-skill select[name=${field}]`).parentNode.style.display = 'none';
		});

		const type = event.target.value;
		let showFields = ['skill_pierce','skill_power','skill_magazine'];
		switch(type) {

			case 'Buff':
				showFields = ['skill_effect_time'];
				break;
			case 'Debuff':
				showFields = ['skill_effect_time'];
				break;	
			case 'Recovery':
				showFields = ['skill_recovery'];
				break;
			case 'Awakening':
				showFields = ['skill_effect_time'];
				break;				 			
			default:
				break;
		}

		showFields.forEach((field) => {

			document.querySelector(`.fields-add-skill select[name=${field}]`).parentNode.style.display = 'inline-block';
		});
	};

	const submitSkill = () => {		

		const skill = document.querySelector('.fields-add-skill');
		const skillName = skill.querySelector('input[name=skill_name]').value;
		const skillDescription = skill.querySelector('textarea[name=skill_description]').value;
		let hasErrors = false;

		if ( checkIfHasEmpty([skillName, skillDescription])) {

			showStatusMessage('You must provide a valid Name and Description.','skill');
			hasErrors = true;			
		}
		
		if ( !hasErrors ) {
		
			const skillType = skill.querySelector('select[name=skill_type]').value;
			const skillPierce = skill.querySelector('select[name=skill_pierce]').value;
			const skillPower = skill.querySelector('select[name=skill_power]').value;
			const skillMagazine = skill.querySelector('select[name=skill_magazine]').value;
			const skillRecovery = skill.querySelector('select[name=skill_recovery]').value;
			const skillEffectTime = skill.querySelector('select[name=skill_effect_time]').value;
			const skillCooldown = skill.querySelector('select[name=skill_cooldown]').value;
			const skillCooldownFirst = skill.querySelector('select[name=skill_cooldown_first]').value;

			let skillFieldNames = ['skill_name', 'skill_type', 'skill_cooldown', 'skill_description'];

			switch(skillType) {

				case 'Buff':
					skillFieldNames.push('skill_effect_time');
					break;
				case 'Debuff':
					skillFieldNames.push('skill_effect_time');
					break;	
				case 'Recovery':
					skillFieldNames.push('skill_recovery');
					break;
				case 'Awakening':
					skillFieldNames.push('skill_effect_time');
					break;				 			
				default:
					skillFieldNames.push('skill_pierce','skill_power','skill_magazine')
					break;
			}

			let validSkillFields = {
				'skill_name': skillName,
				'skill_type': skillType,
				'skill_pierce': skillPierce,
				'skill_power': skillPower,
				'skill_magazine': skillMagazine,
				'skill_recovery': skillRecovery,
				'skill_effect_time': skillEffectTime,
				'skill_cooldown': skillCooldown + `(first time ${skillCooldownFirst})`,
				'skill_description': skillDescription,
			};

			for (const field in validSkillFields) {

				if ( !skillFieldNames.includes(field)) {

					validSkillFields[field] = '';
				}
			}

			addNewSkill([validSkillFields]);
		}

	}

	return (

		<div className='ph2 fields-add-skill'>
			<h2>Add New Skill</h2>
			<div className='status-box-skill h2 bg-red white flex items-center ph3 b'>&nbsp;</div>
			<div className='pv2 f7 green'>
				{
					recentlyAddedSkill.length > 0 ?
						recentlyAddedSkill.map((skill) => {

							return (
								<div key={skill}>
									<div>Recently add skill:</div>
									<div className='ml2'>{skill.skill_name}</div>
								</div>
							)
						})
						: <span>{addSkillStatus}</span>
				}
			</div>
			<fieldset className='mv2 skill-field f7'>
				<legend className='ph2 dark-blue'>Skill Information</legend>
				<div className='skill-info flex flex-wrap items-start'>
					<label className='ph1 dib f7'>
						<span className='mt2 mb1 db b'>Name</span>
						<input type='text' name='skill_name' />
					</label>						
					<label className='ph1 dib f7'>
						<span className='mt2 mb1 db b'>Type</span>
						<select name='skill_type' onChange={setSkillType}>
							{
								SKILL_TYPES.map(item => {

									return <option key={'type-' + item} value={item}>{item}</option>
								})
							}
						</select>
					</label>
					<label className='ph1 dib f7'>
						<span className='mt2 mb1 db b'>Pierce</span>
						<select name='skill_pierce'>
							{
								SKILL_RATINGS.map(item => {

									return <option key={'pierce-' + item} value={item}>{item}</option>
								})
							}
						</select>
					</label>
					<label className='ph1 dib f7'>
						<span className='mt2 mb1 db b'>Power</span>
						<select name='skill_power'>
							{
								SKILL_RATINGS.map(item => {

									return <option key={'power-' + item} value={item}>{item}</option>
								})
							}
						</select>
					</label>
					<label className='ph1 dib f7'>
						<span className='mt2 mb1 db b'>Magazine</span>
						<select name='skill_magazine'>
							{
								SKILL_MAGAZINES.map(item => {

									return <option key={'magazine-' + item} value={item}>{item}</option>
								})
							}
						</select>
					</label>
					<label className='ph1 dn f7'>
						<span className='mt2 mb1 db b'>Recovery</span>
						<select name='skill_recovery'>
							{
								SKILL_RECOVERIES.map(item => {

									return <option key={'recovery-' + item} value={item}>{item}</option>
								})
							}
						</select>
					</label>
					<label className='ph1 dn f7'>
						<span className='mt2 mb1 db b'>Effect Time</span>
						<select name='skill_effect_time'>
							{
								SKILL_EFFECT_TIMES.map(item => {

									return <option key={'effect-' + item} value={item}>{item}</option>
								})
							}
						</select>
					</label>
					<label className='ph1 dib f7 nowrap'>
						<span className='mt2 mb1 db b'>Cooldown</span>
						<select name='skill_cooldown'>
							{
								SKILL_COOLDOWNS.map(item => {

									return <option key={'cooldown-' + item} value={item}>{item}</option>
								})
							}
						</select>
						<select name='skill_cooldown_first'>
							{
								SKILL_COOLDOWNS_FIRST.map(item => {

									return <option key={'cooldown-first-' + item} value={item}>{item} (first time)</option>
								})
							}
						</select>
					</label>						
					<label className='ph1 dib f7 w20' style={{flexGrow: 1}}>
						<span className='mt2 mb1 db b'>Description</span>
						<textarea name='skill_description' className='h3 pa1 w-100'></textarea>
					</label>
				</div>
			</fieldset>
			<div className='tr pa2'>
				<button className='pa2 mr0 pointer grow bg-brand-magenta white bn pv2 ph3' onClick={submitSkill}>Add Skill</button>
			</div>			
		</div>
	);
};

export default AddSkill;